(function () {
 function isDesktop(){return window.innerWidth >= 990;}
 var touchTime=0;
 var menus=[];
 function init(){
  menus=[];
  document.querySelectorAll('.header__inline-menu header-menu').forEach(function(host){
   var details=host.querySelector('details.mega-menu');
   var summary=details&&details.querySelector('summary');
   if(!summary||!details.querySelector('.zabdi-mega__panel'))return;
   var m={host:host,details:details,summary:summary,timer:null};
   menus.push(m);
   if(host.dataset.zabdiInstantBound)return;
   host.dataset.zabdiInstantBound='1';
   function open(){
    if(!isDesktop())return;
    clearTimeout(m.timer);
    menus.forEach(function(other){if(other.host!==host)close(other);});
    details.open=true;summary.setAttribute('aria-expanded','true');
   }
   summary.addEventListener('pointerenter',function(e){if((e.pointerType==='mouse'||e.pointerType==='pen')&&Date.now()-touchTime>650)open();});
   host.addEventListener('mouseenter',function(){clearTimeout(m.timer);});
   host.addEventListener('mouseleave',function(){if(isDesktop())m.timer=setTimeout(function(){if(!host.contains(document.activeElement))close(m);},95);});
   summary.addEventListener('click',function(e){if(e.detail!==0&&isDesktop()&&Date.now()-touchTime>650&&details.open){e.preventDefault();e.stopImmediatePropagation();open();}},true);
   host.addEventListener('keydown',function(e){if(e.key==='Escape'){close(m);summary.focus();}});
  });
 }
 function close(m){clearTimeout(m.timer);m.details.open=false;m.summary.setAttribute('aria-expanded','false');}
 document.addEventListener('pointerdown',function(e){if(e.pointerType==='touch')touchTime=Date.now();menus.forEach(function(m){if(m.details.open&&!m.host.contains(e.target))close(m);});},true);
 document.addEventListener('touchstart',function(){touchTime=Date.now();},{passive:true});
 window.addEventListener('resize',function(){if(!isDesktop())menus.forEach(close);});
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();